const angularModule = angular.module('com.comtrade.azureCloud.backup.dashboard.components', []);

angularModule.component('backupsWidget', require('./backupsWidget/backupsWidget.component'));
angularModule.component('targetsWidget', require('./targetsWidget/targetsWidget.component'));
angularModule.component('virtualMachinesWidget', require('./virtualMachinesWidget/virtualMachinesWidget.component'));
angularModule.component('eventsWidget', require('./eventsWidget/eventsWidget.component'));
angularModule.component('policiesWidget', require('./policiesWidget/policiesWidget.component.js'));
angularModule.component('jobsWidget', require('./jobsWidget/jobsWidget.component'));
angularModule.component('protectionWidget', require('./protectionWidget/protectionWidget.component'));
angularModule.component('statusWidget', require('./statusWidget/statusWidget.component'));

module.exports = angularModule;



// WEBPACK FOOTER //
// ./src/azurebackup/views/dashboard/components/components.module.js